<app-header-page>
    <h1>{{ 'HEADERS.DOC_REGISTRY' | translate }}</h1>
</app-header-page>

<div class="page-content">
    <div class="projects_page">
        <div class="project_page">
            <div class="folder_table">
                <div class="head">
                    <div class="col_1 sorting">
                        <span>{{ 'DOCUMENTS.TITLES.NUMBER' | translate }}</span>
                        <i class="icon-up_2"></i>
                    </div>
                    <div class="col_2 registry_title sorting">
                        <span>{{ 'DOCUMENTS.TITLES.NAME' | translate }}</span>
                        <i class="icon-up_2"></i>
                    </div>
                    <div class="col_3">
                        <span>{{ 'DOCUMENTS.TITLES.SIGN_AT' | translate }}</span>
                        <i class="icon-up_2"></i>
                    </div>
                    <div class="col_4">
                        <span>{{ 'DOCUMENTS.TITLES.SIGNERS' | translate }}</span>
                        <i class="icon-up_2"></i>
                    </div>
                    <div class="mobile_more"></div>
                </div>
                <ng-container *ngIf="loading">
                    <div>
                        <div class="donut"
                             style="border-left-color: #808090; padding: 0; margin: auto"></div>
                    </div>
                </ng-container>
                <ng-container *ngIf="!data.length && !loading">
                    <a>
                        <div style="display: block; width: 100%;">
                            <h3 style="text-align: center;">
                                {{ 'EMPTY_LISTS.REGISTRY' | translate }}
                            </h3>
                        </div>
                    </a>
                </ng-container>
                <ng-container *ngIf="data">
                    <ng-container *ngFor="let item of data; let i = index">
                        <div (click)="collapse(i)"
                             [attr.data-index-item]="i"
                             class="row_list"
                        >
                            <div class="col_1 set-wrap">
                                {{ i + 1 }}
                            </div>
                            <div class="col_2 registry_title set-wrap">
								<span>
									<i class="icon-list"></i>
									<span>{{ item.name }}</span>
									<i (click)="navigateDoc(item, $event)"
                                       class="bi bi-eye text-success ms-1"
                                       style="cursor: pointer"
                                    ></i>
								</span>
                            </div>
                            <div class="col_3 set-wrap">
                                <span style="padding-right: 20px;">{{ item.signed_at | date:'HH:mm dd.MM.yyyy' }}</span>
                            </div>
                            <div class="col_4 set-wrap">
                                <span class="green">{{ 'DOCUMENTS.TEXT.TOTAL' | translate }}
                                    : {{ item.signers_guids.length }}</span>
                            </div>
                            <div [class.reverse]="item.collapse"
                                 class="collapse_desc"
                                 data-action="collapseItem"
                            >
                                <i class="icon-up"></i>
                            </div>
                        </div>
                        <div *ngIf="item.collapse"
                             [@fade]="'in'"
                             class="row_desc">
                            <div *ngFor="let user of item.signers_guids; let iu = index;"
                                 [attr.data-index-user]="iu"
                                 class="row_adds">
                                <div (click)="navigateDoc(item)"
                                     class="col__1_2 set-wrap">
                                    <small class="doc_name">
                                        {{ !iu ? item.chain_hash : '' }}
                                    </small>
                                </div>
                                <div class="col_3 set-wrap">
                                    <small>
                                        {{ user.sign_at | date:'HH:mm dd.MM.yyyy' }}
                                    </small>
                                </div>
                                <div class="col_4 set-wrap">
                                    <p style="margin: 0">
                                        <small (click)="openProfile(user.user.guid)"
                                               [class.blocked_user]="user.user.observation_type === 'blocked'"
                                               [class.inactive_user]="!user.user.is_active"
                                               class="user_card"
                                               data-action="openProfile"
                                        >
                                            <img *ngIf="user.user.project_setting.is_project_admin"
                                                 alt="#"
                                                 ngbTooltip="{{ 'USER_PROFILE.ROLE.ADMIN' | translate }}"
                                                 src="../../../../assets/images/admin.svg">
                                            {{ helpers.fullName(user.user) }}
                                        </small>
                                    </p>
                                </div>
                            </div>
                        </div>
                    </ng-container>
                </ng-container>
            </div>
        </div>
    </div>
    <app-component-pagination (page)="changePage($event)"
                              *ngIf="!loading"
                              [pagination]="pagination"

                              [totalPages]="pagination.pages"
    ></app-component-pagination>
</div>

<ng-template #docView
             let-modal>
    <app-button-modal-close [modalSize]="'xl'"
                            [modal]="modal"></app-button-modal-close>
    <div class="modal-body">
        <app-component-doc-view
                (deleteEmit)="modal.close()"
                [fileUkey]="docKey"
                [isOpenModal]="true">
        </app-component-doc-view>
    </div>
</ng-template>
